export default {
  placeholder: 'Select a user',
};
